import { siteInfo } from "@/mocks/siteContent";
import SectionHeader from "./SectionHeader";

const principles = [
  {
    icon: "ri-4k-fill",
    title: "高清画质",
    text: "坚持呈现清晰细腻的高清画面，让每一格分镜、每一处色彩细节都值得放大欣赏。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "每日更新",
    text: "平台每日更新热门作品，持续上新，让你第一时间追到正在火热连载的佳作。",
  },
  {
    icon: "ri-apps-2-fill",
    title: "分类齐全",
    text: "恋爱、奇幻、校园、悬疑等题材分类清晰，辅助标签与筛选，找漫画不再大海捞针。",
  },
  {
    icon: "ri-trophy-line",
    title: "完结排行榜",
    text: "集中整理高分完结佳作并动态排序，帮不爱追更的读者快速锁定可以一口气读完的故事。",
  },
];

export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <SectionHeader
              eyebrow="关于我们"
              title="让每一部好漫画，都值得被看见"
              desc="我们是一群热爱漫画的读者与创作者，创办高清韩国漫画，只为让更多人在轻松清晰的体验中，发现属于自己心动题材的故事。"
            />
            <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
              {siteInfo.description} 无论是想追更恋爱的怦然心动、沉浸奇幻世界的冒险，还是回味校园青春、破解悬疑谜团，这里都有贴合你口味的作品。我们从读者视角出发，认真做分类、做排行、做更新，让挑选和阅读都更简单、更愉悦。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#categories"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
              >
                <i className="ri-compass-3-line" aria-hidden="true" />
                浏览全部分类
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-50"
              >
                联系我们
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div
                key={p.title}
                className="rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700">
                  <i className={p.icon} aria-hidden="true" />
                </span>
                <h3 className="mt-3 font-heading text-lg text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}